 App.service('API',['$http',function ($http) {
     var operator_token = '4f06af92a8314e0c7240c40a1ff99346'
     this.post = function (url,data) {
       // data.token = localStorage.getItem(accessTokenGlobal);
        return $http({
            method: "post",
            url:  url,
            data: data,
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'operator-token': operator_token},
            transformRequest: function (data) {
                return $.param(data);
            }
        }).then(function (result) {
            return result
        }, function (err) {
            
        })
    };

     this.postWithAccessToken = function (url,data) {
         // data.token = localStorage.getItem(accessTokenGlobal);
         return $http({
             method: "post",
             url:  url,
             data: data,
             headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                 'operator-token': operator_token,
                  'access-token': localStorage.getItem('access_token')},
             transformRequest: function (data) {
                 return $.param(data);
             }
         }).then(function (result) {
             return result
         }, function (err) {

         })
     };

     this.uploadImagePostRequest = function (url,data) {
         // data.token = localStorage.getItem(accessTokenGlobal);
         return $http({
             method: "post",
             url:  url,
             data: data,
             headers: {'Content-Type': undefined,
                 'operator-token': operator_token,
                 'access-token': localStorage.getItem('access_token')},
             transformRequest: angular.identity
         }).then(function (result) {
             return result
         }, function (err) {

         })
     };

    this.get = function (url) {
        return $http.get(url)
            .then(function (result) {
                return result;
            }, function (err) {
                
            })
    };

    this.form = function (url, formData) {

    }

}]);